module.exports = __webpack_public_path__ + "assets/static/png/network-marketing-red.d823e52519eb18a52af75653d28d7298.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/network-marketing-red.png
 ** module id = 516
 ** module chunks = 1
 **/